import React from 'react';
import classNames from "classnames";


export function ExampleContent(props) {


    const exampleClass = classNames("example rounded p-5 pt-2 border-2 border border-dark shadow ")
    return (

        <div className={"d-flex justify-content-center my-4"}>
            <div className={exampleClass}>

                <div className={"mt-4"}>
                    {props.children}
                </div>
            </div>
        </div>


    );




}